import { api_DELETE, api_GET, api_POST, api_PUT } from "./_api.js";

const solicitacaoFiscalizacao_api = {
    getList: (filtros) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`SolicitacaoFiscalizacao/GetList/`, filtros)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    getListPendentes: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`SolicitacaoFiscalizacao/GetFiscalizacoesPendentes/WEB`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getSolicitacaoFiscalizacaoAnexos: (solicitacaoFiscalizacao_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`SolicitacaoFiscalizacao/GetSolicitacaoFiscalizacaoAnexos/${solicitacaoFiscalizacao_Id}`)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    getListProximos: (idSolicitacao) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`SolicitacaoFiscalizacao/GetListProximos/${idSolicitacao}`)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    agruparSolicitacoes: (agrupamento) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`SolicitacaoFiscalizacao/AgruparSolicitacoes/`, agrupamento)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    deletarAgrupamento: (idAgrupamento) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`SolicitacaoFiscalizacao/DeletarAgrupamento/${idAgrupamento}`)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`SolicitacaoFiscalizacao/GetItem/${id}`)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`SolicitacaoFiscalizacao`, json)
                .then(result => {
                    resolve(result)
                })
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (regional) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`SolicitacaoFiscalizacao`, regional)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default solicitacaoFiscalizacao_api;
